
import { useTranslation } from "react-i18next";
import { CompaniesSearch } from "@/components/companies/CompaniesSearch";
import { useCompaniesFilter } from "@/contexts/CompaniesFilterContext";
import {
  COMPANY_RELATIONSHIPS,
  CompanyRelationship,
  getRelationshipBadgeClasses,
  getRelationshipLabel,
} from "@/utils/companyRelationship";

export const CompaniesFilterWrapper = () => {
  const { t } = useTranslation();
  const {
    searchTerm,
    setSearchTerm,
    showFavoritesOnly,
    setShowFavoritesOnly,
    relationshipFilter,
    setRelationshipFilter,
    setCurrentPage
  } = useCompaniesFilter();

  // Reset to first page when filters change
  const handleSearchTermChange = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };

  const handleShowFavoritesOnlyChange = (show: boolean) => {
    setShowFavoritesOnly(show);
    setCurrentPage(1);
  };

  const toggleRelationship = (rel: CompanyRelationship) => {
    const next = relationshipFilter.includes(rel)
      ? relationshipFilter.filter(r => r !== rel)
      : [...relationshipFilter, rel];
    setRelationshipFilter(next);
    setCurrentPage(1);
  };

  return (
    <>
      <CompaniesSearch
        searchTerm={searchTerm}
        setSearchTerm={handleSearchTermChange}
        showFavoritesOnly={showFavoritesOnly}
        setShowFavoritesOnly={handleShowFavoritesOnlyChange}
      />
      <div className="mb-4 flex items-center gap-2 flex-wrap">
        <span className="text-xs font-medium text-gray-600 dark:text-gray-400">
          {t("companies.relationship.filterLabel")}:
        </span>
        {COMPANY_RELATIONSHIPS.map(rel => {
          const active = relationshipFilter.includes(rel);
          return (
            <button
              key={rel}
              type="button"
              onClick={() => toggleRelationship(rel)}
              className={`px-2.5 py-1 rounded-sm text-xs font-medium transition-colors border ${
                active
                  ? `${getRelationshipBadgeClasses(rel)} border-transparent`
                  : 'bg-transparent text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800'
              }`}
            >
              {getRelationshipLabel(rel, t)}
            </button>
          );
        })}
      </div>
    </>
  );
};
